import { Button, DefaultSheet, SheetBody } from 'twyne-new.ui';

import { ConsentDBAsContextProvider, useConsentDBAsContext } from './Context';
import { ConsentDBAsProvider } from './store';

function DefaultContent({ children, Trigger = DefaultTrigger, Modal = DefaultModal }) {
  const { modal: { open, toggle } } = useConsentDBAsContext()

  return <>
    <Trigger onClick={toggle} />
    <Modal isOpen={open} toggle={toggle}>
      {children}
    </Modal>
  </>
}

export function DefaultModal({ isOpen, toggle, children }) {
  return <DefaultSheet
    wrapperProps={{ open: isOpen, onOpenChange: toggle }}
    title='TCPA Consent DBA'
    triggerProps={{ asChild: true, className: 'hidden' }}
  >
    <SheetBody className='mb-16'>
      {children}
    </SheetBody>
  </DefaultSheet>
}

export function DefaultTrigger({ onClick }) {
  return <Button variant='ghost' color='accent' size='sm' onClick={onClick}>
    Configure Consent DBA's
  </Button>
}

export function DefaultConsentDBAsProvider({ children }) {
  return <ConsentDBAsContextProvider>
    <ConsentDBAsProvider>
      {children}
    </ConsentDBAsProvider>
  </ConsentDBAsContextProvider>
}

export default function DefaultConsentDBAs({ children, ...props }) {
  return <DefaultConsentDBAsProvider>
    <DefaultContent {...props}>
      {children}
    </DefaultContent>
  </DefaultConsentDBAsProvider>
}
